import { render } from "./AuthorizationPage.vue?vue&type=template&id=a2d843e4&scoped=true"
import script from "./AuthorizationPage.vue?vue&type=script&lang=js"
export * from "./AuthorizationPage.vue?vue&type=script&lang=js"

import "./AuthorizationPage.vue?vue&type=style&index=0&id=a2d843e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d843e4"]])

export default __exports__